import React from 'react';
import PropTypes from 'prop-types';
import { Divider, makeStyles, Toolbar } from '@material-ui/core';
import { Button, Flex } from '@knockrentals/knock-shared-web-v2';
import { ButtonPill } from '../../../../knock-design-system';
import { CloneIcon, ShowHideChannelsIcon } from '../../../../Components/Icons';
import { DRAWER_MODES } from '../constants';

const useStyles = makeStyles({
  divider: {
    '&.MuiDivider-vertical': {
      marginTop: 0,
    },
  },
  toolbar: {
    justifyContent: 'space-between',
    paddingTop: '16px',
  },
});

export const ActionButtonsToolbar = ({
  handleDrawerMode,
  isClonePropertiesDisabled,
  isManageChannelsButtonDisabled,
}) => {
  const classes = useStyles();

  return (
    <Toolbar className={classes.toolbar} variant="dense">
      <ButtonPill>Properties: All</ButtonPill>

      <Flex alignItems="center" gap={16}>
        <Button
          color="primary"
          onClick={handleDrawerMode(DRAWER_MODES.FILTER)}
          size="small"
          startIcon={<ShowHideChannelsIcon />}
          variant="text"
        >
          Show/Hide Channels
        </Button>

        <Button
          color="primary"
          disabled={isClonePropertiesDisabled}
          onClick={handleDrawerMode(DRAWER_MODES.CLONE)}
          size="small"
          startIcon={<CloneIcon />}
          variant="text"
        >
          Clone Property
        </Button>

        <Divider className={classes.divider} flexItem orientation="vertical" />

        <Button
          color="primary"
          disabled={isManageChannelsButtonDisabled}
          onClick={handleDrawerMode(DRAWER_MODES.MANAGE)}
          size="small"
          variant="text"
        >
          Manage Channels (0)
        </Button>
      </Flex>
    </Toolbar>
  );
};

ActionButtonsToolbar.propTypes = {
  handleDrawerMode: PropTypes.func,
  isClonePropertiesDisabled: PropTypes.bool,
  isManageChannelsButtonDisabled: PropTypes.bool,
};
